"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutliDragAwareReorder = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var mutliDragAwareReorder = exports.mutliDragAwareReorder = function mutliDragAwareReorder(args) {
  if (args.selectedOptions.length > 1) {
    return reorderMultiDrag(args);
  }
  return reorderSingleDrag(args);
};
var reorder = function reorder(list, startIndex, endIndex) {
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(endIndex, 0, removed);
  return result;
};
var reorderSingleDrag = function reorderSingleDrag(_ref) {
  var options = _ref.options,
    source = _ref.source,
    destination = _ref.destination;
  return reorder(options, source.index, destination.index);
};
var reorderMultiDrag = function reorderMultiDrag(_ref2) {
  var options = _ref2.options,
    selectedOptions = _ref2.selectedOptions,
    destination = _ref2.destination,
    source = _ref2.source;
  var dragged = options[source.index];
  var insertAtIndex = function () {
    var destinationIndexOffset = selectedOptions.reduce(function (previous, current) {
      if (current === dragged) {
        return previous;
      }
      var index = options.indexOf(current);
      if (index >= destination.index) {
        return previous;
      }
      return previous + 1;
    }, 0);
    return destination.index - destinationIndexOffset;
  }();
  var orderedSelectedOptions = _toConsumableArray(selectedOptions);
  orderedSelectedOptions.sort(function (a, b) {
    if (a === dragged) {
      return -1;
    }
    if (b === dragged) {
      return 1;
    }
    var indexOfA = options.indexOf(a);
    var indexOfB = options.indexOf(b);
    if (indexOfA !== indexOfB) {
      return indexOfA - indexOfB;
    }

    // sorting by their order in the selectedTaskIds list
    return -1;
  });
  var withRemovedTasks = options.filter(function (task) {
    return !selectedOptions.includes(task);
  });
  var withInserted = function () {
    var base = _toConsumableArray(withRemovedTasks);
    base.splice.apply(base, [insertAtIndex, 0].concat(_toConsumableArray(selectedOptions)));
    return base;
  }();
  return withInserted;
};